import {
  addDoc,
  collection,
  doc,
  getDocs,
  serverTimestamp,
  updateDoc,
  writeBatch,
} from "firebase/firestore";

import { getDownloadURL, ref, uploadBytes } from "firebase/storage";

import * as XLSX from "xlsx";

import imageCompression from "browser-image-compression";

import { db, storage } from "../firebase";

import {
  crearIdCategoria,
  normalizarTextoCategoria,
} from "../utils/categorias";

function useProductosManager({
  setProductos,
  setCategoriasExistentes,
  setBanners,
  setEspeciales,
  setPromociones,
  setMensaje,
  setCargando,
  setCargandoExcel,
  setPestañaActiva,
  setIdSeleccionado,
  setNombre,
  setDescripcion,
  setPrecio,
  setTurno,
  setSeccion,
  setImagenArchivo,
  setOpcionesSinCosto,
  setExtrasLista,
  productos,
  nombre,
  descripcion,
  precio,
  seccion,
  imagenArchivo,
  turno,
  opcionesSinCosto,
  extrasLista,
  idSeleccionado,

  categoriasConfiguradas = [],
  categoriaNuevaDetectada = false,
  ordenCategoriaNueva = "",
  turnoCategoriaProducto = "matutino",
  categoriasOrdenadasDelTurno = [],
  cargarCategoriasConfiguradas,
}) {
  const obtenerNumeroOrden = (valor) => {
    const numero = Number(valor);

    if (!Number.isFinite(numero)) {
      return 0;
    }

    return Math.trunc(numero);
  };

  const crearErrorUsuario = (mensaje) => {
    const error = new Error(mensaje);
    error.mensajeUsuario = mensaje;
    return error;
  };

  const crearCategoriaNuevaSiAplica = async () => {
    if (idSeleccionado) {
      return;
    }

    const categoriaNormal = normalizarTextoCategoria(seccion);

    if (!categoriaNormal) {
      return;
    }

    const turnoCategoria = turnoCategoriaProducto || "matutino";
    const turnoNormal = normalizarTextoCategoria(turnoCategoria);

    const categoriaYaExiste = categoriasConfiguradas.some((categoria) => {
      return (
        normalizarTextoCategoria(categoria.turno) === turnoNormal &&
        normalizarTextoCategoria(categoria.nombre) === categoriaNormal
      );
    });

    if (categoriaYaExiste) {
      return;
    }

    const ordenNuevo = obtenerNumeroOrden(ordenCategoriaNueva);
    const ordenMaximoPermitido = categoriasOrdenadasDelTurno.length + 1;

    if (!ordenNuevo || ordenNuevo < 1) {
      throw crearErrorUsuario(
        "⚠️ La nueva categoría necesita un número de orden válido.",
      );
    }

    if (ordenNuevo > ordenMaximoPermitido) {
      throw crearErrorUsuario(
        `⚠️ No puedes brincar números. Para este turno el máximo permitido es ${ordenMaximoPermitido}.`,
      );
    }

    const categoriaConOrdenOcupado = categoriasOrdenadasDelTurno.find(
      (categoria) => obtenerNumeroOrden(categoria.orden) === ordenNuevo,
    );

    if (categoriaConOrdenOcupado) {
      const confirmarInsertar = window.confirm(
        `El orden ${ordenNuevo} ya está ocupado por "${categoriaConOrdenOcupado.nombre}".\n\nSi continúas, "${categoriaNormal}" entrará en la posición ${ordenNuevo} y las categorías desde esa posición se recorrerán un número.\n\n¿Continuar?`,
      );

      if (!confirmarInsertar) {
        throw crearErrorUsuario("ℹ️ Guardado cancelado.");
      }
    }

    const batch = writeBatch(db);

    categoriasOrdenadasDelTurno
      .filter((categoria) => obtenerNumeroOrden(categoria.orden) >= ordenNuevo)
      .forEach((categoria) => {
        batch.update(doc(db, "categorias", categoria.id), {
          orden: obtenerNumeroOrden(categoria.orden) + 1,
          fechaActualizacion: serverTimestamp(),
        });
      });

    const idCategoria = crearIdCategoria(turnoCategoria, categoriaNormal);

    batch.set(
      doc(db, "categorias", idCategoria),
      {
        nombre: categoriaNormal,
        turno: turnoCategoria,
        orden: ordenNuevo,
        activa: true,
        fechaCreacion: serverTimestamp(),
        fechaActualizacion: serverTimestamp(),
      },
      { merge: true },
    );

    await batch.commit();

    if (typeof cargarCategoriasConfiguradas === "function") {
      await cargarCategoriasConfiguradas();
    }
  };
  const cargarProductos = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "productos"));

      const lista = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setProductos(lista);

      const cats = lista
        .map((p) => (p.seccion ? p.seccion.toUpperCase().trim() : ""))
        .filter(
          (value, index, self) => value !== "" && self.indexOf(value) === index,
        );

      setCategoriasExistentes(cats);

      const bannersSnapshot = await getDocs(collection(db, "marketing"));

      setBanners(
        bannersSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        })),
      );

      const especialesSnapshot = await getDocs(collection(db, "especiales"));

      setEspeciales(
        especialesSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        })),
      );

      const promosSnapshot = await getDocs(collection(db, "promociones"));

      setPromociones(
        promosSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        })),
      );
    } catch (error) {
      console.error(error);
    }
  };

  const limpiarFormulario = () => {
    setIdSeleccionado(null);

    setNombre("");

    setDescripcion("");

    setPrecio("");

    setTurno("matutino");

    setSeccion("");

    setImagenArchivo(null);

    setOpcionesSinCosto([]);

    setExtrasLista([]);

    const inputFoto = document.getElementById("input-foto");

    if (inputFoto) inputFoto.value = "";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!nombre || !descripcion || !precio || !seccion) {
      setMensaje("⚠️ Completa campos obligatorios.");

      return;
    }

    setCargando(true);

    setMensaje("");

    try {
      await crearCategoriaNuevaSiAplica();

      let urlImagenFinal = "https://via.placeholder.com/90";

      if (imagenArchivo) {
        const nombreUnico = `${Date.now()}_${imagenArchivo.name}`;

        const storageRef = ref(storage, `productos/${nombreUnico}`);

        const compressedFile = await imageCompression(imagenArchivo, {
          maxSizeMB: 0.4,
          maxWidthOrHeight: 1280,
          useWebWorker: true,
        });

        await uploadBytes(storageRef, compressedFile);

        urlImagenFinal = await getDownloadURL(storageRef);
      } else if (idSeleccionado) {
        const productoActual = productos.find((p) => p.id === idSeleccionado);

        if (productoActual) {
          urlImagenFinal = productoActual.imagen;
        }
      }

      const datosProducto = {
        nombre,
        descripcion,
        precio: Number(precio),
        imagen: urlImagenFinal,
        turno,
        seccion: seccion.trim().toUpperCase(),
        opcionesSinCosto: opcionesSinCosto || [],
        extras: extrasLista,
      };

      if (idSeleccionado) {
        const docRef = doc(db, "productos", idSeleccionado);

        await updateDoc(docRef, datosProducto);

        setMensaje("🎉 Producto actualizado.");

        setTimeout(() => setPestañaActiva("inventario"), 1000);
      } else {
        const productosRef = collection(db, "productos");

        await addDoc(productosRef, {
          ...datosProducto,
          disponible: true,
          bloqueadoHasta: null,
        });

        setMensaje("✅ Producto agregado.");
      }

      limpiarFormulario();

      cargarProductos();
      if (typeof cargarCategoriasConfiguradas === "function") {
        await cargarCategoriasConfiguradas();
      }
    } catch (error) {
      if (error?.mensajeUsuario) {
        setMensaje(error.mensajeUsuario);
      } else {
        console.error(error);
        setMensaje("❌ Error guardando producto.");
      }
    } finally {
      setCargando(false);
    }
  };

  const handleSeleccionarEditar = (prod) => {
    setIdSeleccionado(prod.id);

    setNombre(prod.nombre);

    setDescripcion(prod.descripcion || "");

    setPrecio(prod.precio);

    setTurno(prod.turno || "matutino");

    setSeccion(prod.seccion ? prod.seccion.toUpperCase() : "");

    setOpcionesSinCosto(prod.opcionesSinCosto || []);

    setExtrasLista(prod.extras || []);

    setPestañaActiva("registrar");

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleCambiarDisponibilidad = async (prod, tipoBloqueo) => {
    try {
      const docRef = doc(db, "productos", prod.id);

      let disponible = true;

      let bloqueadoHasta = null;

      if (tipoBloqueo === "24h") {
        disponible = false;

        const tiempoLimite = new Date();

        tiempoLimite.setHours(tiempoLimite.getHours() + 24);

        bloqueadoHasta = tiempoLimite.toISOString();
      } else if (tipoBloqueo === "indefinido") {
        disponible = false;

        const tiempoLejano = new Date("2040-01-01");

        bloqueadoHasta = tiempoLejano.toISOString();
      } else if (tipoBloqueo === "activar") {
        disponible = true;

        bloqueadoHasta = null;
      }

      await updateDoc(docRef, {
        disponible,
        bloqueadoHasta,
      });

      setMensaje(`⚙️ Estado actualizado.`);

      cargarProductos();
    } catch (error) {
      console.error(error);

      setMensaje("❌ Error disponibilidad.");
    }
  };

  const parsearOpcionesSinCostoExcel = (texto = "") => {
    const textoLimpio = String(texto || "").trim();

    if (!textoLimpio) return [];

    return textoLimpio
      .split(";")
      .map((bloque) => {
        const partes = bloque.split("|").map((parte) => parte.trim());

        const nombreOpcion = partes[0] || "";
        const tipo = partes[1] || "unica";
        const requeridoTexto = partes[2] || "opcional";
        const opcionesTexto = partes[3] || "";

        const opciones = opcionesTexto
          .split(",")
          .map((opcion) => opcion.trim())
          .filter(Boolean);

        if (!nombreOpcion || opciones.length === 0) return null;

        return {
          nombre: nombreOpcion,
          tipo: tipo === "multiple" ? "multiple" : "unica",
          requerido: requeridoTexto.toLowerCase() === "requerido",
          opciones,
        };
      })
      .filter(Boolean);
  };

  const normalizarTurnoExcel = (valor) => {
    const turnoNormal = String(valor || "matutino")
      .toLowerCase()
      .trim();

    if (["matutino", "vespertino", "ambos"].includes(turnoNormal)) {
      return turnoNormal;
    }

    return "matutino";
  };

  const obtenerTurnoCategoriaExcel = (turnoProducto) => {
    // Por ahora, si el producto es de ambos turnos,
    // usamos matutino como referencia del orden de categoría.
    // Después podemos hacer que cree la categoría en ambos turnos si lo necesitas.
    if (turnoProducto === "ambos") {
      return "matutino";
    }

    return turnoProducto || "matutino";
  };

  const prepararCategoriasDesdeExcel = async (productosPreparados = []) => {
    const snapshotCategorias = await getDocs(collection(db, "categorias"));

    const categoriasFirestore = snapshotCategorias.docs.map((documento) => ({
      id: documento.id,
      ...documento.data(),
    }));

    const categoriasPorTurno = new Map();

    categoriasFirestore.forEach((categoria) => {
      const turnoNormal = normalizarTextoCategoria(
        categoria.turno || "matutino",
      );

      if (!categoriasPorTurno.has(turnoNormal)) {
        categoriasPorTurno.set(turnoNormal, []);
      }

      categoriasPorTurno.get(turnoNormal).push({
        ...categoria,
        orden: obtenerNumeroOrden(categoria.orden),
        nueva: false,
        modificada: false,
      });
    });

    categoriasPorTurno.forEach((listaCategorias) => {
      listaCategorias.sort(
        (a, b) => obtenerNumeroOrden(a.orden) - obtenerNumeroOrden(b.orden),
      );
    });

    const categoriasExcelMap = new Map();

    productosPreparados.forEach((producto) => {
      const turnoCategoria = obtenerTurnoCategoriaExcel(producto.turno);
      const turnoNormal = normalizarTextoCategoria(turnoCategoria);
      const categoriaNormal = normalizarTextoCategoria(producto.seccion);
      const ordenCategoria = obtenerNumeroOrden(producto.ordenCategoria);

      if (!categoriaNormal) return;

      const clave = `${turnoNormal}__${categoriaNormal}`;

      if (!categoriasExcelMap.has(clave)) {
        categoriasExcelMap.set(clave, {
          turnoCategoria,
          turnoNormal,
          categoriaNormal,
          grupoCategoria: producto.grupoCategoria || "ALIMENTOS",
          ordenCategoria,
        });

        return;
      }

      const categoriaExistente = categoriasExcelMap.get(clave);

      if (
        ordenCategoria &&
        categoriaExistente.ordenCategoria &&
        ordenCategoria !== categoriaExistente.ordenCategoria
      ) {
        throw new Error(
          `La categoría "${categoriaNormal}" aparece con dos órdenes diferentes en el Excel: ${categoriaExistente.ordenCategoria} y ${ordenCategoria}.`,
        );
      }

      if (!categoriaExistente.ordenCategoria && ordenCategoria) {
        categoriaExistente.ordenCategoria = ordenCategoria;
      }
    });

    const categoriasExcel = Array.from(categoriasExcelMap.values());

    for (const categoriaExcel of categoriasExcel) {
      const listaTurno =
        categoriasPorTurno.get(categoriaExcel.turnoNormal) || [];

      const yaExiste = listaTurno.find(
        (categoria) =>
          normalizarTextoCategoria(categoria.nombre) ===
          categoriaExcel.categoriaNormal,
      );

      if (yaExiste) {
        if (
          categoriaExcel.ordenCategoria &&
          obtenerNumeroOrden(yaExiste.orden) !== categoriaExcel.ordenCategoria
        ) {
          throw new Error(
            `La categoría "${categoriaExcel.categoriaNormal}" ya existe con orden ${yaExiste.orden}, pero el Excel trae orden ${categoriaExcel.ordenCategoria}. Ajusta el Excel o cambia el orden desde la pestaña Categorías.`,
          );
        }

        continue;
      }

      if (!categoriaExcel.ordenCategoria || categoriaExcel.ordenCategoria < 1) {
        throw new Error(
          `La categoría nueva "${categoriaExcel.categoriaNormal}" necesita ordenCategoria en el Excel.`,
        );
      }

      const maximoPermitido = listaTurno.length + 1;

      if (categoriaExcel.ordenCategoria > maximoPermitido) {
        throw new Error(
          `No puedes brincar números. La categoría "${categoriaExcel.categoriaNormal}" trae orden ${categoriaExcel.ordenCategoria}, pero el máximo permitido para ese turno es ${maximoPermitido}.`,
        );
      }

      listaTurno.forEach((categoria) => {
        if (
          obtenerNumeroOrden(categoria.orden) >= categoriaExcel.ordenCategoria
        ) {
          categoria.orden = obtenerNumeroOrden(categoria.orden) + 1;
          categoria.modificada = true;
        }
      });

      const idCategoria = crearIdCategoria(
        categoriaExcel.turnoCategoria,
        categoriaExcel.categoriaNormal,
      );

      listaTurno.push({
        id: idCategoria,
        nombre: categoriaExcel.categoriaNormal,
        turno: categoriaExcel.turnoCategoria,
        grupo: categoriaExcel.grupoCategoria,
        orden: categoriaExcel.ordenCategoria,
        activa: true,
        nueva: true,
        modificada: true,
      });

      listaTurno.sort(
        (a, b) => obtenerNumeroOrden(a.orden) - obtenerNumeroOrden(b.orden),
      );

      categoriasPorTurno.set(categoriaExcel.turnoNormal, listaTurno);
    }

    const batch = writeBatch(db);

    let categoriasCreadas = 0;
    let categoriasReacomodadas = 0;

    categoriasPorTurno.forEach((listaCategorias) => {
      listaCategorias.forEach((categoria) => {
        if (!categoria.modificada && !categoria.nueva) return;

        const refCategoria = doc(db, "categorias", categoria.id);

        if (categoria.nueva) {
          batch.set(
            refCategoria,
            {
              nombre: categoria.nombre,
              turno: categoria.turno,
              grupo: categoria.grupo || "ALIMENTOS",
              orden: obtenerNumeroOrden(categoria.orden),
              activa: true,
              fechaCreacion: serverTimestamp(),
              fechaActualizacion: serverTimestamp(),
            },
            { merge: true },
          );

          categoriasCreadas += 1;
          return;
        }

        batch.update(refCategoria, {
          orden: obtenerNumeroOrden(categoria.orden),
          fechaActualizacion: serverTimestamp(),
        });

        categoriasReacomodadas += 1;
      });
    });

    await batch.commit();

    return {
      categoriasCreadas,
      categoriasReacomodadas,
    };
  };

  const handleCargaMasivaExcel = async (e) => {
    const archivo = e.target.files[0];

    if (!archivo) return;

    setCargandoExcel(true);
    setMensaje("");

    const lector = new FileReader();

    lector.onload = async (evento) => {
      try {
        const datosBinarios = evento.target.result;

        const libroTrabajo = XLSX.read(datosBinarios, {
          type: "binary",
        });

        const nombreHoja = libroTrabajo.SheetNames[0];
        const hojaActual = libroTrabajo.Sheets[nombreHoja];
        const filasJson = XLSX.utils.sheet_to_json(hojaActual);

        if (filasJson.length === 0) {
          setMensaje("⚠️ Excel vacío.");
          setCargandoExcel(false);
          return;
        }

        const productosPreparados = [];
        let omitidosContador = 0;

        for (const fila of filasJson) {
          const nombreProducto = fila.nombre ? String(fila.nombre).trim() : "";

          const descripcionProducto = fila.descripcion
            ? String(fila.descripcion).trim()
            : "";

          const precioProducto = Number(fila.precio);

          const categoriaProducto = fila.categoria
            ? normalizarTextoCategoria(fila.categoria)
            : fila.seccion
              ? normalizarTextoCategoria(fila.seccion)
              : "";

          const turnoProducto = normalizarTurnoExcel(fila.turno);

          const ordenCategoria = obtenerNumeroOrden(
            fila.ordenCategoria || fila.orden_categoria || fila.orden,
          );

          const grupoCategoria = normalizarTextoCategoria(
            fila.grupo || "ALIMENTOS",
          );

          if (
            !nombreProducto ||
            !categoriaProducto ||
            !precioProducto ||
            Number.isNaN(precioProducto)
          ) {
            omitidosContador++;
            continue;
          }

          productosPreparados.push({
            nombreProducto,
            descripcionProducto,
            precioProducto,
            categoriaProducto,
            seccion: categoriaProducto,
            turnoProducto,
            turno: turnoProducto,
            grupoCategoria,
            ordenCategoria,
            opcionesTexto: fila.opciones ? String(fila.opciones).trim() : "",
            extrasTexto: fila.extras ? String(fila.extras).trim() : "",
          });
        }

        if (productosPreparados.length === 0) {
          setMensaje("⚠️ No encontramos productos válidos para importar.");
          setCargandoExcel(false);
          return;
        }

        const resultadoCategorias =
          await prepararCategoriasDesdeExcel(productosPreparados);

        const productosRef = collection(db, "productos");

        let subidosContador = 0;

        for (const productoPreparado of productosPreparados) {
          const opcionesImportadas = parsearOpcionesSinCostoExcel(
            productoPreparado.opcionesTexto,
          );

          const extrasImportados =
            productoPreparado.extrasTexto !== ""
              ? productoPreparado.extrasTexto
                  .split(/[;,]/)
                  .map((extra) => {
                    const partes = extra.split(":");

                    const nombreExtra = partes[0]
                      ? String(partes[0]).trim()
                      : "";

                    const precioExtra = partes[1]
                      ? Number(String(partes[1]).trim())
                      : 0;

                    if (!nombreExtra) return null;

                    return {
                      nombre: nombreExtra,
                      precio: Number.isNaN(precioExtra) ? 0 : precioExtra,
                    };
                  })
                  .filter(Boolean)
              : [];

          await addDoc(productosRef, {
            nombre: productoPreparado.nombreProducto,
            descripcion:
              productoPreparado.descripcionProducto || "Platillo Mítico.",
            precio: productoPreparado.precioProducto,
            seccion: productoPreparado.categoriaProducto,
            turno: productoPreparado.turnoProducto,
            imagen: "https://via.placeholder.com/90",
            opcionesSinCosto: opcionesImportadas,
            extras: extrasImportados,
            disponible: true,
            bloqueadoHasta: null,
          });

          subidosContador++;
        }

        setMensaje(
          `🎉 ${subidosContador} productos importados. Categorías creadas: ${resultadoCategorias.categoriasCreadas}. Categorías reacomodadas: ${resultadoCategorias.categoriasReacomodadas}. ${
            omitidosContador > 0 ? `⚠️ ${omitidosContador} filas omitidas.` : ""
          }`,
        );

        const inputExcel = document.getElementById("input-excel-masivo");

        if (inputExcel) inputExcel.value = "";

        await cargarProductos();

        if (typeof cargarCategoriasConfiguradas === "function") {
          await cargarCategoriasConfiguradas();
        }
      } catch (error) {
        console.error(error);
        setMensaje(`❌ Error leyendo el Excel: ${error.message}`);
      } finally {
        setCargandoExcel(false);
      }
    };

    lector.readAsBinaryString(archivo);
  };

  return {
    cargarProductos,
    handleSubmit,
    handleSeleccionarEditar,
    handleCambiarDisponibilidad,
    handleCargaMasivaExcel,
    limpiarFormulario,
  };
}

export default useProductosManager;
